import {
  FormGroup,
  HTMLSelect,
} from "@blueprintjs/core";
import {
  MDBCol,
} from "mdbreact";
import { observer } from "mobx-react";
import * as React from "react";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";

interface EmpresaTributacaoProps {
  handleSimplesNacionalExcesso: (vl: string) => void;
  handleSimplesNacionalSelect: (vl: string) => void;
  haldleDisableValidSimples: () => void;
  handleRegimeEspecialSelect: (vl: string) => void;
  handleAutoPecasSelect: (vl: string) => void;
  handleConvenioIcms10097Select: (vl: string) => void;
  handleMedicamentoUsoVeterinarioSelect: (vl: string) => void;
  handlePortaaPortaSelect: (vl: string) => void;
  handleIssTributadoFixoSelect: (vl: string) => void;
}

interface EmpresaTributacaoState {
  handleSimplesNacionalExcesso: (vl: string) => void;
  handleSimplesNacionalSelect: (vl: string) => void;
  haldleDisableValidSimples: () => void;
  handleRegimeEspecialSelect: (vl: string) => void;
  handleAutoPecasSelect: (vl: string) => void;
  handleConvenioIcms10097Select: (vl: string) => void;
  handleMedicamentoUsoVeterinarioSelect: (vl: string) => void;
  handlePortaaPortaSelect: (vl: string) => void;
  handleIssTributadoFixoSelect: (vl: string) => void;
}

@observer
export default class EmpresaTributacao
  extends React.Component<EmpresaTributacaoProps, EmpresaTributacaoState> {
  constructor(props) {
    super(props);

    this.state = {
      handleSimplesNacionalSelect: props.handleSimplesNacionalSelect,
      haldleDisableValidSimples: props.haldleDisableValidSimples,
      handleRegimeEspecialSelect: props.handleRegimeEspecialSelect,
      handleAutoPecasSelect: props.handleAutoPecasSelect,
      handleConvenioIcms10097Select: props.handleConvenioIcms10097Select,
      handleMedicamentoUsoVeterinarioSelect: props.handleMedicamentoUsoVeterinarioSelect,
      handleSimplesNacionalExcesso: props.handleSimplesNacionalExcesso,
      handlePortaaPortaSelect: props.handlePortaaPortaSelect,
      handleIssTributadoFixoSelect: props.handleIssTributadoFixoSelect

    };
  }

  render() {
    return (
      <>
        <MDBCol md="8">

          <div style={{ width: 1000 }}>

            <FormGroup label="Regime Simples Nacional">
              <HTMLSelect onChange={e => this.state.handleSimplesNacionalSelect(e.target.value)} value={EmpresaStore.obs.empresa_edit.simples_nacional ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            {EmpresaStore.obs.empresa_edit.simples_nacional &&
              <FormGroup label="Excesso de Sublimite de Receita Bruta">
                <HTMLSelect onChange={e => this.state.handleSimplesNacionalExcesso(e.target.value)} value={EmpresaStore.obs.empresa_edit.simples_nacional_excesso ? "1" : "0"}>
                  <option value="0">Não</option>
                  <option value="1">Sim</option>
                </HTMLSelect>
              </FormGroup>
            }

            <FormGroup label="Regime Especial">
              <HTMLSelect onChange={e => this.state.handleRegimeEspecialSelect(e.target.value)} value={EmpresaStore.obs.empresa_edit.regime_especial_icms_pa ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label="Convênio ICMS 100/97">
              <HTMLSelect onChange={e => this.state.handleConvenioIcms10097Select(e.target.value)} value={EmpresaStore.obs.empresa_edit.convenio_icms_100_97 ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label="Comercializa Medicamentos Veterinários, PET.">
              <HTMLSelect onChange={e => this.state.handleMedicamentoUsoVeterinarioSelect(e.target.value,)} value={EmpresaStore.obs.empresa_edit.medicamento_uso_veterinario ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label="Comercializa Produtos Auto Peças">
              <HTMLSelect onChange={e => this.state.handleAutoPecasSelect(e.target.value)} value={EmpresaStore.obs.empresa_edit.auto_pecas ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label="Operação de Venda na Modalidade Porta a Porta">
              <HTMLSelect onChange={e => this.state.handlePortaaPortaSelect(e.target.value)} value={EmpresaStore.obs.empresa_edit.porta_a_porta ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1" >Sim</option>
              </HTMLSelect>
            </FormGroup>

            {EmpresaStore.obs.empresa_edit.uf == "RS" &&
              <FormGroup label="ISS Tributado fixo">
                <HTMLSelect onChange={e => this.state.handleIssTributadoFixoSelect(e.target.value)} value={EmpresaStore.obs.empresa_edit.tributa_fixo_iss ? "1" : "0"}>
                  <option value="0">Não</option>
                  <option value="1" >Sim</option>
                </HTMLSelect>
              </FormGroup>
            }

          </div>

        </MDBCol>

      </>
    );
  }
}
